module.exports = (require("./helpers/browser/js-loader")(require('./helpers/bundle-manifest').resolve("g9CMS"))).then(() => parcelRequire('d0iPb'));